import { createTheme } from "@mui/material";

export const USER_STATUS_OPTIONS = [
  { value: "active", label: "Active" },
  { value: "pending", label: "Pending" },
  { value: "banned", label: "Banned" },
  { value: "rejected", label: "Rejected" },
];

export const USER_PLANS = [
  {
    subscription: "basic",
    price: 0,
    primary: false,
  },
  {
    subscription: "starter",
    price: 4.99,
    primary: true,
  },
  {
    subscription: "premium",
    price: 9.99,
    primary: false,
  },
];

export const PRODUCT_SORT_OPTIONS = [
  { value: "featured", label: "Featured" },
  { value: "newest", label: "Newest" },
  { value: "priceDesc", label: "Price: High - Low" },
  { value: "priceAsc", label: "Price: Low - High" },
];

export const JOB_SKILL_OPTIONS = [
  "UI",
  "UX",
  "Html",
  "JavaScript",
  "TypeScript",
  "Communication",
  "Problem Solving",
  "Leadership",
  "Time Management",
  "Adaptability",
  "Collaboration",
  "Creativity",
  "Critical Thinking",
  "Technical Skills",
  "Customer Service",
  "Project Management",
  "Problem Diagnosis",
];

export const JOB_EXPERIENCE_OPTIONS = [
  { value: "No experience", label: "No experience" },
  { value: "1 year exp", label: "1 year exp" },
  { value: "2 year exp", label: "2 year exp" },
  { value: "> 3 year exp", label: "> 3 year exp" },
];

export const theme = createTheme({
  palette: {
    primary: {
      main: "#6B5B95",
    },
    secondary: {
      main: "#FFFFFF",
    },
    background: {
      default: "#FFFFFF",
      paper: "#F8F7FA",
    },
    text: {
      primary: "#000000",
      secondary: "#666666",
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: "24px",
      fontWeight: 600,
      color: "#000000",
    },
    h2: {
      fontSize: "48px",
      fontWeight: 600,
      lineHeight: 1.2,
      color: "#000000",
    },
    body1: {
      fontSize: "16px",
      color: "#000000",
    },
    body2: {
      fontSize: "14px",
      color: "#666666",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: "8px",
          padding: "8px 16px",
          fontSize: "16px",
        },
        contained: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          maxWidth: "1440px",
          "@media (min-width: 1200px)": {
            maxWidth: "1440px",
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            backgroundColor: "#ffffff",
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#E0E0E0",
            },
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#E0E0E0",
            borderWidth: "1px",
            borderRadius: "8px",
          },
          "& .MuiInputLabel-root": {
            color: "#000000",
            transform: "none",
            position: "static",
            marginBottom: "8px",
            fontSize: "16px",
            fontWeight: 400,
            "&.Mui-focused": {
              color: "#000000",
            },
            "&.MuiFormLabel-filled": {
              transform: "none",
            },
            "&.Mui-required": {
              transform: "none",
            },
          },
          "& .MuiInputBase-input": {
            padding: "12px 16px",
            height: "24px",
            color: "#000000",
            fontSize: "16px",
            "&::placeholder": {
              color: "#666666",
              opacity: 1,
            },
          },
          "& .MuiFormLabel-root": {
            position: "static",
            transform: "none",
            padding: 0,
          },
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: "#666666",
          textDecoration: "none",
          fontSize: "14px",
          "&:hover": {
            textDecoration: "none",
          },
          "&.signup-link": {
            color: "#6B5B95",
            fontWeight: 500,
          },
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: "#000000",
          "&.or-divider": {
            borderColor: "#000000",
            borderWidth: "0.5px",
          },
        },
      },
    },
  },
});
